<header class="main-menu" [ngClass]="{'preLogin': !user}">
  <div class="d-flex">
    <div class="logo">
      <a [routerLink]="activeLink === homeLink ? null:[homeLink]" aria-label="Redirect to Home" (click)="closeMenu()">
        @if (!user) {
          <img alt="Nicola Wealth logo" src="assets/images/nicola_wealth_full_logo_white_rgb_2026.svg" />
        }
        @if (user) {
          <img alt="Nicola Wealth Logo" src="assets/images/nicola-wealth-white.svg"/>
        }
      </a>
    </div>
    @if (user) {
      <div class="rergSelector">
        <input type="checkbox" id="rerg-selector-toggle" [(ngModel)]="rergSelectorShown">
        <!--   for a11y, the keyboard enter should open/close the menu. It was better not to add (keydown) to label but it needed more changes in this section  -->
        <label tabindex="0" (keydown)="keyDownOnReRgSelector($event)" [ngClass]="{selectable:user.reRgs && user.reRgs.length>1}" for="rerg-selector-toggle" click-stop-propagation>
          <i class="material-icons">expand_more</i>
          <span>{{displayName}}</span>
          @if (user.reRgs && user.reRgs.length>1) {
            <div class="subItems py-2">
              <ul class="black-link">
                @for (reRg of user.reRgs; track reRg) {
                  <li>
                    <button (click)="setReRg(reRg)" class="accountOption" [ngClass]="{'active':currentReRg?.ReRgId === reRg.ReRgId}">
                      @if (currentReRg?.ReRgId === reRg.ReRgId) {
                        <span class="material-icons">done</span>
                      }
                      <span class="accountName">{{reRg.ClientName}}</span>
                    </button>
                  </li>
                }
              </ul>
            </div>
          }
        </label>
      </div>
    }
    <div class="navigation" role="navigation">
      <ul>
        @for (menuItem of availableMenuItems; track menuItem) {
          <li class="{{menuItem.class}}" [ngClass]="{icon:menuItem.icon}">
            <ng-container *ngTemplateOutlet="menuLink; context:{ $implicit: menuItem }" />
            @if (menuItem.subItems) {
              <div class="subItems">
                <div class="welcome">WELCOME</div>
                <b>{{user?.displayName}}</b>
                <hr>
                  <ul class="black-link">
                    @for (subItem of menuItem.subItems; track subItem) {
                      <li>
                        <ng-container *ngTemplateOutlet="menuLink; context:{ $implicit: subItem }" />
                      </li>
                    }
                  </ul>
                </div>
              }
            </li>
          }
        </ul>
      </div>
    </div>

    <div class="hamburger-menu">
      <input type="checkbox" id="hamburger-menu-toggle" (change)="menuToggle()" [(ngModel)]="menuOpened">
      <!--   for a11y, the keyboard enter should open/close the menu. It was better not to add (keydown) to label but it needed more changes in this section  -->
      <label (keydown)="keyDownOnMenu($event)" tabindex="0"  for="hamburger-menu-toggle" class="hamburger-menu-button">
        <i class="fa fa-bars"></i>
      </label>
      <div class="hamburger-menu-content pt-4">
        <div class="welcome">WELCOME</div>
        <b>{{user?.displayName}}</b>
        <hr class="mt-2">
        <ul class="black-link pt-1">
          @for (menuItem of availableMenuItems; track menuItem) {
            @if (!menuItem.subItems) {
              <li class="{{menuItem.class}}" [ngClass]="{icon:menuItem.icon}">
                @if (menuItem.link.indexOf('http')!==0) {
                  <a [routerLink]="menuItem.link ? [menuItem.link] : null" routerLinkActive="active" (click)="menuItemClick(menuItem)">
                    {{menuItem.title}}
                  </a>
                }
              </li>
            }
            @if (menuItem.subItems) {
              <hr>
                @for (subItem of menuItem.subItems; track subItem) {
                  <li>
                    <ng-container *ngTemplateOutlet="menuLink; context:{ $implicit: subItem }" />
                  </li>
                }
              }
            }
          </ul>
        </div>
      </div>
    </header>

    <ng-template #menuLink let-menuItem>
      @if (menuItem.link.indexOf('http')===0) {
        <a href="{{menuItem.link}}" (click)="menuItemClick(menuItem)" target="_blank" tabindex="0">{{menuItem.title}}</a>
      }
      @if (menuItem.link.indexOf('http')!==0) {
        <a [routerLink]="menuItem.link ? [menuItem.link] : null" routerLinkActive="active" tabindex="0" (click)="menuItemClick(menuItem)" [ngClass]="{icon:menuItem.icon}">
          @if (menuItem.icon) {
            <span class="material-icons" [title]="menuItem.title">{{menuItem.icon}}</span>
          }
          @if (!menuItem.icon) {
            {{menuItem.title}}
          }
        </a>
      }
      @if (menuItem.link === "/notifications" && notificationsCount > 0) {
        <i class="notificationsCount">{{notificationsCount}}</i>
      }
    </ng-template>
